import { Controller } from "stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  connect() {
    this.tomSelect = new TomSelect(this.element, {});
  }
}
